// extracted by mini-css-extract-plugin
export default {"main":"App_main__nhgh3","suspenseFallback":"App_suspenseFallback__QOedI"};